/**
 * Pay date generation utilities shared between useAutoPostings and PaycheckSnapshot.
 */

export function lastDayOfMonth(year, month) {
  return new Date(year, month + 1, 0).getDate();
}

export function adjustForWeekend(date) {
  const d = new Date(date);
  const day = d.getDay();
  if (day === 6) d.setDate(d.getDate() - 1);
  if (day === 0) d.setDate(d.getDate() - 2);
  return d;
}

export function toDateStr(d) {
  return d.toLocaleDateString('sv-SE');
}

export function generateSemiMonthlyDates(year) {
  const today = new Date();
  today.setHours(23, 59, 59, 999);
  const dates = [];
  for (let month = 0; month < 12; month++) {
    const mid = adjustForWeekend(new Date(year, month, 15));
    const eom = adjustForWeekend(new Date(year, month, lastDayOfMonth(year, month)));
    if (mid <= today) dates.push(mid);
    if (eom <= today) dates.push(eom);
  }
  return dates;
}

export function generateBiweeklyDates(year, anchorDateStr) {
  const today = new Date();
  today.setHours(23, 59, 59, 999);
  const anchor = new Date(anchorDateStr + 'T00:00:00');
  const yearStart = new Date(year, 0, 1);
  const yearEnd = new Date(year, 11, 31, 23, 59, 59);
  const dates = [];
  let d = new Date(anchor);
  while (d > yearStart) d = new Date(d.getTime() - 14 * 86400000);
  while (d <= yearEnd) {
    if (d >= yearStart && d <= today) dates.push(new Date(d));
    d = new Date(d.getTime() + 14 * 86400000);
  }
  return dates;
}

export function generatePayDates(year, frequency, anchorDate) {
  if (frequency === 'biweekly') return generateBiweeklyDates(year, anchorDate);
  return generateSemiMonthlyDates(year);
}

export function generateMonthlyDates(year, dayOfMonth) {
  const today = new Date();
  today.setHours(23, 59, 59, 999);
  const dates = [];
  for (let month = 0; month < 12; month++) {
    const last = lastDayOfMonth(year, month);
    const day = Math.min(dayOfMonth, last);
    const d = new Date(year, month, day);
    if (d <= today) dates.push(d);
  }
  return dates;
}
